import type {
  AdHocAssetsShare,
  CollectionShare,
} from '@frameio/graphql-client/generated';

/**
 * @docs A type guard for `AdHocAssetsShare`s. Given a `share` of any type, the
 * guard will inform the type-checker whether it's an `AdHocAssetShare`.
 */
export function isAdHocShare<
  T extends Pick<AdHocAssetsShare | CollectionShare, '__typename'>,
>(share: T): share is Extract<T, { __typename?: 'AdHocAssetsShare' }> {
  return share.__typename === 'AdHocAssetsShare';
}
